import {
  Info as Icon // TODO: select an icon
} from 'components/icons';

export const meta = {
  id: '__demosDetails',
  title: '__demosDetails',
  category: 'Demo',
  unique: false,
  icon: Icon,
  version: '1.0.0',
  description: `Just a demo. Feel free to delete it if you are familiarized with the structure `,
  windowOptions: {
    // if not passed, will be centered
    // x: null,
    // y: null,
    width: 440,
    height: 410
  }
};
